const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        username: true,
        email: true
      },
      oauth: {
        domain: process.env.REACT_APP_COGNITO_DOMAIN,
        scope: ['openid', 'email', 'profile'],
        responseType: 'code',
        redirectSignIn: window.location.origin,
        redirectSignOut: window.location.origin
      }
    }
  }
};

export default awsconfig;
